import React, { useEffect, useRef, useState } from 'react';
import {
  CloseIcon,
  Container,
  ContainerInfoFile,
  ContainerUpload,
  Error,
  ErrorContainer,
  FileField,
  NameFile,
  UploadIcon,
} from './UploadFile.styles';
import IconPNG from './assets/svgs/PNG';
import IconJPG from './assets/svgs/JPG';
import { UploadFileProps } from './UploadFile.types';

/**
 * Verifica se o tamanho do arquivo ultrapassa o limite de 300 KB.
 * Isso é necessário porque o DynamoDB possui um limite de 400 KB por item, e o Base64 aumenta o tamanho do arquivo em cerca de 33%.
 * TODO: Armazenar o arquivo em um bucket S3 e salvar apenas a referência no DynamoDB.
 */
const verifyFileSize = (file: File) => {
  const MAX_FILE_SIZE_MB = 0.3;
  const MAX_FILE_SIZE = 1024 * 1024 * MAX_FILE_SIZE_MB;

  return file.size > MAX_FILE_SIZE;
};

export function UploadFile(props: UploadFileProps): JSX.Element {
  const [hasFile, setHasFile] = useState(props.hasFile);
  const inputRef = useRef(null) as any;
  const [error, setError] = useState('');

  const TYPE_ICONS: any = {
    'image/jpg': <IconJPG width="2rem" />,
    'image/png': <IconPNG width="2rem" />,
  };

  useEffect(() => {
    setHasFile(props.hasFile);
  }, [props.hasFile]);

  const readFile = (fileList: FileList | null) => {
    setError('');

    if (fileList && fileList[0]) {
      if (verifyFileSize(fileList[0])) {
        setError('O arquivo deve ter no máximo 300KB');
        return;
      }

      const reader = new FileReader();
      reader.readAsDataURL(fileList[0]);
      reader.onload = function () {
        props.onChange({ file: reader.result as string });
        setHasFile(true);
      };
      reader.onerror = (error) => {
        console.error(error);
      };
    }
  };

  const reset = () => {
    inputRef.current.value = null;
    props.onChange({ file: '' });
    setHasFile(false);
  };

  return (
    <Container>
      {!hasFile && (
        <ContainerUpload onClick={() => inputRef?.current?.click()}>
          <UploadIcon size={20} />
          <p>Enviar arquivo</p>
        </ContainerUpload>
      )}

      {hasFile && (
        <ContainerInfoFile>
          {TYPE_ICONS[inputRef?.current?.files[0]?.type]}
          <NameFile>Arquivo enviado</NameFile>
          <UploadIcon size={25} onClick={() => inputRef?.current?.click()} />
          <CloseIcon size={30} onClick={reset} />
        </ContainerInfoFile>
      )}

      <FileField
        ref={inputRef}
        id="logoFile"
        type="file"
        onChange={(e) => readFile(e.target.files)}
        accept="image/gif, image/jpeg, image/png"
      />

      <ErrorContainer>
        <Error>{error}</Error>
      </ErrorContainer>
    </Container>
  );
}
